<template>
  <div class="vertically-centered-container">
    <slot/>
  </div>
</template>

<script>
export default {
  name: 'VerticallyCenteredContainer'
}
</script>

<style scoped>
.vertically-centered-container {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
</style>
